// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","nav":"Header_nav__LNsaU","panel":"Header_panel__2rzkT","logo":"Header_logo__3T0lc"};